import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "23.9915",
      cy: "13.0071",
      r: "9.9993",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M41.5962 45.9904V37.7578C41.5962 33.3395 38.0145 29.7578 33.5962 29.7578H23.9973H14.3984C9.98016 29.7578 6.39844 33.3395 6.39844 37.7578V45.9904",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }